module.exports = __webpack_public_path__ + "src/modules/home/training/images/1706.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/home/training/images/1706.png
// module id = 789
// module chunks = 0